module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0034.png.cb4e0510.jpg";